import { alpha3Codes, countries } from 'countries-ts';

const countryLabelByCode = new Map<string, string>();

for (const country of countries as any[]) {
  const alpha2 = country.code?.toUpperCase();
  const label = country.label;

  if (!alpha2 || !label) {
    continue;
  }

  countryLabelByCode.set(alpha2, label);
  countryLabelByCode.set(label.toUpperCase(), label);

  const alpha3 = (alpha3Codes as Record<string, string>)[alpha2];
  if (alpha3) {
    countryLabelByCode.set(alpha3.toUpperCase(), label);
  }
}

export function getCountryLabel(value?: string | null): string {
  if (!value) {
    return '';
  }

  const normalizedValue = value.toString().trim();
  return countryLabelByCode.get(normalizedValue.toUpperCase()) || normalizedValue;
}

export function mapCountryIdValueOption(
  id: string,
  labelOrCode?: string | null
): { id: string; value: string } {
  return {
    id,
    value: getCountryLabel(labelOrCode || id),
  };
}

export function mapCountryDropdownItem(item: any): any {
  if (!item) {
    return item;
  }

  return {
    ...item,
    item_text: getCountryLabel(item.item_text || item.item_id),
  };
}

export function mapCountryDropdownItems(items: any[] = []): any[] {
  return items.map((item) => mapCountryDropdownItem(item));
}
